function appendTextBelow() {
  const modalBodyContent = document.querySelector(".md-modal__grid__1");
  if (modalBodyContent) {
    const textElement = document.createElement("p");
    // Get translated text from window.orbeTranslations or fallback to English
    const disclaimerText = window.orbeTranslations?.disclaimer ||
      "Please note that the catalog, services and prices may change depending on the country selected. Any products in the shopping cart will be removed.";
    textElement.textContent = disclaimerText;
    textElement.classList.add("text-xs-light", "text-below-modal");
    modalBodyContent.appendChild(textElement);
  }
}

function addStyles() {
  const confirmButton = document.getElementById("md-btn__form__onSubmit");
  const countryDropdown = document.getElementById("md-form__select__country");
  const languageDropdown = document.getElementById("md-form__select__language");
  const countryLabel = document.getElementById("label-md-form__country-code");
  const languageLabel = document.getElementById("label-md-form__language-code");
  const modalText = document.querySelector(".md-modal__bodyContent__helperText");
  const modalTitle = document.querySelector(".md-modal__bodyContent__text");
  const modalHeader = document.getElementById("label-md-modal__dialog");

  confirmButton.classList.remove("md-btn__primary", "md-btn");
  confirmButton.classList.add("button", "button--solid", "button--primary");
  confirmButton.style.cssText = `order: 2;`;
  const countryLabelText = window.orbeTranslations?.countryLabel || "Change country";
  const languageLabelText = window.orbeTranslations?.languageLabel || "Select your language";
  countryLabel.textContent = countryLabelText;
  countryLabel.classList.add("dropdown-modal-label", "text-xs");
  countryDropdown.classList.add("dropdown-modal");
  languageLabel.textContent = languageLabelText;
  languageLabel.classList.add("dropdown-modal-label", "text-xs");
  languageDropdown.classList.add("dropdown-modal");
  modalText.classList.add("text-s");
  modalTitle.classList.add("text-l-light");
  modalHeader.classList.add("text-s", "modal-header-text");
}
document.addEventListener("DOMContentLoaded", function () {
  addStyles();
  appendTextBelow();

});
